import { s as h } from "../../../Warning.d17948db.js";
import { s as m } from "../../../Check.494f5056.js";
import { s as d } from "../../../Info.02a86612.js";
import { s as g } from "../../../Error.54275a94.js";
import { s as u } from "../../../Lightbulb.f8781bc3.js";
import { s as b } from "../../../Close.f6105da6.js";
import { L as v, A as p, x as e, r as y } from "../../../leaf-element.4609dd44.js";
import { n as l } from "../../../query-assigned-elements.57643bdd.js";
import "../button/button.js";
import "../link/link.js";
import "../heading/heading.js";
import "../text-passage/text-passage.js";
import "../../../index.b3318e8d.js";
import { l as x } from "../../../if-defined.f8bcf4f6.js";
import "../../../query.c9d8c980.js";
import "../leaf-form-element.js";
import "../../../loading-spinner.5ae0fff0.js";
const _ = `*,::slotted(*),*:before,*:after{box-sizing:border-box}:root,:host{--size-base-unit: .5rem}[dir=rtl]{--rtlTranslateX: 50%;--rtlGradientToRight: 270deg;--rtlRotate45Inverse: -45deg}:host{--leaf-z-index-1: 1;--leaf-z-index-50: 50;--leaf-z-index-100: 100;--leaf-z-index-200: 200;--leaf-z-index-1030: 1030;--leaf-anim-fade-quick: .35s;--leaf-anim-ease: ease}@keyframes fadeIn{to{opacity:1}}@keyframes slideIn{to{transform:translate(0)}}@keyframes slideInFwd{to{width:272px;height:272px}}@keyframes slideOutRight{to{width:272px;height:272px}}@keyframes slideUp{to{transform:translateY(0)}}@media (width >= 481px){@keyframes slideInFwd{to{width:417px;height:417px}}@keyframes slideOutRight{to{width:417px;height:417px}}}@media (width >= 48rem){@keyframes slideInFwd{to{width:330px;height:330px}}@keyframes slideOutRight{to{width:330px;height:330px;transform:translate(calc(100vw - 45px))}}}@media (width >= 60rem){@keyframes slideInFwd{to{width:460px;height:460px}}@keyframes slideOutRight{to{width:460px;height:460px;transform:translate(calc(100vw - 45px))}}}@media (width >= 75rem){@keyframes slideInFwd{to{width:592px;height:591px}}@keyframes slideOutRight{to{width:592px;height:591px;transform:translate(calc(100vw - 45px))}}}@media (width >= 87.5rem){@keyframes slideOutRight{to{width:592px;height:591px;transform:translate(calc(100vw - 120px))}}}@media (width >= 2200px){@keyframes slideOutRight{to{width:592px;height:591px;transform:translate(calc(100vw - 592px))}}}span.ripple{position:absolute;border-radius:50%;transform:scale(0);animation:ripple .6s linear;background-color:var(--ripple-bg-color)}@keyframes ripple{to{transform:scale(4);opacity:1}}dialog{background:none;border:0;color:inherit;max-height:none;max-width:none;padding:0;position:static;width:100%}dialog::backdrop{background:none;height:auto}.leaf-c-alert{align-self:stretch;border-radius:var(--leaf-border-radius-default);border-style:var(--leaf-border-style-default);border-width:var(--leaf-border-width-default);padding:var(--leaf-spacing-16);width:auto}.leaf-c-alert .leaf-c-alert__container{box-sizing:border-box;display:flex;gap:var(--leaf-spacing-8);justify-self:center;max-width:1200px;width:100%}.leaf-c-alert .leaf-c-alert__container .leaf-c-alert__message-container{color:var(--leaf-color-content-knockout);display:flex;flex-direction:column;width:100%}.leaf-c-alert .leaf-c-alert__container .leaf-c-alert__message-container .leaf-c-alert__heading-container{align-items:center;display:flex;justify-content:space-between;padding-bottom:var(--leaf-spacing-4);position:relative}.leaf-c-alert .leaf-c-alert__container .leaf-c-alert__message-container .leaf-c-alert__heading-container h3{font-family:var(--leaf-typography-title-small-mobile-font-family);font-size:var(--leaf-typography-title-small-mobile-font-size);font-weight:var(--leaf-typography-title-small-mobile-font-weight);line-height:var(--leaf-typography-title-small-mobile-line-height);-webkit-text-decoration:var(--leaf-typography-title-small-mobile-text-decoration);text-decoration:var(--leaf-typography-title-small-mobile-text-decoration);text-transform:var(--leaf-typography-title-small-mobile-text-transform);margin:0}@media all and (min-width: 768px){.leaf-c-alert .leaf-c-alert__container .leaf-c-alert__message-container .leaf-c-alert__heading-container h3{font-family:var(--leaf-typography-title-small-font-family);font-size:var(--leaf-typography-title-small-font-size);font-weight:var(--leaf-typography-title-small-font-weight);line-height:var(--leaf-typography-title-small-line-height);-webkit-text-decoration:var(--leaf-typography-title-small-text-decoration);text-decoration:var(--leaf-typography-title-small-text-decoration);text-transform:var(--leaf-typography-title-small-text-transform)}}.leaf-c-alert .leaf-c-alert__container .leaf-c-alert__message-container .leaf-c-alert__body-container{font-family:var(--leaf-typography-body-small-font-family);font-size:var(--leaf-typography-body-small-font-size);font-weight:var(--leaf-typography-body-small-font-weight);line-height:var(--leaf-typography-body-small-line-height);-webkit-text-decoration:var(--leaf-typography-body-small-text-decoration);text-decoration:var(--leaf-typography-body-small-text-decoration);text-transform:var(--leaf-typography-body-small-text-transform);align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:space-between;width:100%}.leaf-c-alert .leaf-c-alert__container .leaf-c-alert__message-container ::slotted([slot=cta]){display:block;margin-top:var(--leaf-spacing-8)}.leaf-c-alert.leaf-c-alert--emphasis-subtle .leaf-c-alert__message-container,.leaf-c-alert.leaf-c-alert--warning .leaf-c-alert__message-container{color:var(--leaf-color-content-default)}.leaf-c-alert--banner{border:0;border-radius:0;left:0;margin-left:calc(-50vw + 50%);margin-right:calc(-50vw + 50%);right:0;width:100vw}.leaf-c-alert--banner .leaf-c-alert__container{position:relative}.leaf-c-alert--standalone{border-radius:var(--leaf-border-radius-default);position:relative}.leaf-c-alert__icon{height:var(--leaf-spacing-16);min-height:var(--leaf-spacing-16);min-width:var(--leaf-spacing-16);width:var(--leaf-spacing-16)}.leaf-c-alert--info,.leaf-c-alert--success,.leaf-c-alert--error,.leaf-c-alert--neutral,.leaf-c-alert--notification{color:var(--leaf-color-content-knockout)}.leaf-c-alert--info{background:var(--leaf-color-bg-info-strong);border-color:var(--leaf-color-border-info)}.leaf-c-alert--info.leaf-c-alert--emphasis-subtle{background:var(--leaf-color-bg-info);color:var(--leaf-color-content-info-icon)}.leaf-c-alert--warning{background:var(--leaf-color-bg-warning-strong);border-color:var(--leaf-color-border-warning);color:var(--leaf-color-content-default)}.leaf-c-alert--warning.leaf-c-alert--emphasis-subtle{background:var(--leaf-color-bg-warning)}.leaf-c-alert--success{background:var(--leaf-color-bg-success-strong);border-color:var(--leaf-color-border-success)}.leaf-c-alert--success.leaf-c-alert--emphasis-subtle{background:var(--leaf-color-bg-success);color:var(--leaf-color-content-success-icon)}.leaf-c-alert--error{background:var(--leaf-color-bg-error-strong);border-color:var(--leaf-color-border-error)}.leaf-c-alert--error.leaf-c-alert--emphasis-subtle{background:var(--leaf-color-bg-error);color:var(--leaf-color-content-error-icon)}.leaf-c-alert--neutral{background:var(--leaf-color-bg-strong);border-color:var(--leaf-color-border-neutral)}.leaf-c-alert--neutral.leaf-c-alert--emphasis-subtle{background:var(--leaf-color-bg-subtle);color:var(--leaf-color-content-default)}.leaf-c-alert--notification{background:var(--leaf-color-bg-attention-strong);border-color:var(--leaf-color-border-attention)}.leaf-c-alert--notification.leaf-c-alert--emphasis-subtle{background:var(--leaf-color-bg-attention);color:var(--leaf-color-content-attention-icon)}leaf-icon{padding-top:var(--leaf-spacing-2)}.leaf-c-alert__close-btn{margin-right:calc(-1 * var(--leaf-spacing-8));margin-top:calc(-1 * var(--leaf-spacing-8))}
`;
var w = Object.defineProperty, k = Object.getOwnPropertyDescriptor, o = (s, a, n, i) => {
  for (var r = i > 1 ? void 0 : i ? k(a, n) : a, c = s.length - 1, f; c >= 0; c--)
    (f = s[c]) && (r = (i ? f(a, n, r) : f(r)) || r);
  return i && r && w(a, n, r), r;
};
class t extends v {
  constructor() {
    super(...arguments), this.emphasis = "subtle", this.headerText = void 0, this.status = "info", this.variant = "standalone", this.checkEmphasisAlert = () => this.emphasis !== "subtle", this.mapStatusToIconAlert = (a) => {
      switch (a) {
        case "error":
          return e`
                    <leaf-icon
                        svg="${g}"
                        aria-label="Error message"
                        class="leaf-c-alert__icon"
                    >
                    </leaf-icon>
                `;
        case "success":
          return e`
                    <leaf-icon
                        svg="${m}"
                        aria-label="Confirmation message"
                        class="leaf-c-alert__icon"
                    >
                    </leaf-icon>
                `;
        case "warning":
          return e`
                    <leaf-icon
                        svg="${h}"
                        aria-label="Warning alert"
                        class="leaf-c-alert__icon"
                    >
                    </leaf-icon>
                `;
        case "notification":
          return e`
                    <leaf-icon
                        svg="${u}"
                        aria-label="General notice"
                        class="leaf-c-alert__icon"
                    >
                    </leaf-icon>
                `;
        case "info":
          return e`
                    <leaf-icon
                        svg="${d}"
                        aria-label="Important information"
                        class="leaf-c-alert__icon"
                    >
                    </leaf-icon>
                `;
        case "neutral":
          return e`
                    <leaf-icon
                        svg="${d}"
                        aria-label="Important information"
                        class="leaf-c-alert__icon"
                    >
                    </leaf-icon>
                `;
        default:
          return p;
      }
    };
  }
  static get styles() {
    return y(_.toString());
  }
  onDismiss() {
    this.dismissed = !0, this.dispatchEvent(new CustomEvent("leaf-alert-dismissed", {
      bubbles: !0,
      composed: !0,
      detail: {
        dismissed: this.dismissed
      }
    }));
  }
  displayCloseButton() {
    return this.notDismissible ? p : e`
            <div>
                <leaf-button
                    class="leaf-c-alert__close-btn"
                    svg="${b}"
                    iconRotateDegree="90"
                    iconPosition="after"
                    variant="tertiary"
                    text="close"
                    size="sm"
                    ?hideText="${!0}"
                    @click="${this.onDismiss}"
                    neutral
                    ?inverse="${this.checkEmphasisAlert() && this.status !== "warning"}"
                >
                </leaf-button>
            </div>
        `;
  }
  render() {
    const a = this.componentClassNames("leaf-c-alert", {
      "leaf-c-alert--error": this.status === "error",
      "leaf-c-alert--info": this.status === "info",
      "leaf-c-alert--notification": this.status === "notification",
      "leaf-c-alert--neutral": this.status === "neutral",
      "leaf-c-alert--success": this.status === "success",
      "leaf-c-alert--warning": this.status === "warning",
      "leaf-c-alert--standalone": this.variant === "standalone",
      "leaf-c-alert--banner": this.variant === "banner",
      "leaf-c-alert--emphasis-subtle": this.emphasis === "subtle",
      "leaf-c-alert--notdismissible": this.notDismissible
    });
    return this.dismissed ? null : e`
                <dialog open>
                    <div
                        class="${a}"
                        role=${x(this.alertRole)}
                    >
                        <div class="leaf-c-alert__container">
                            ${this.status ? e`
                                    ${this.mapStatusToIconAlert(this.status)}
                            ` : ""}
                            <div class="leaf-c-alert__message-container">
                                <div class="leaf-c-alert__heading-container">
                                    ${this.headerText ? e`
                                            <div class="leaf-c-alert__heading-text"><h3>${this.headerText}</h3></div>
                                    ` : ""}
                                </div>
                                <div class="leaf-c-alert__body-container">
                                    <slot></slot>
                                </div>
                                ${this.slotNotEmpty("cta") ? e`
                                        <div class="leaf-c-alert__cta-container">
                                            <slot name="cta"></slot>
                                        </div>
                                ` : ""}
                            </div>
                            ${this.displayCloseButton()}
                        </div>
                    </div>
                </dialog>
            `;
  }
}
o([l({
  reflect: !0
})], t.prototype, "alertRole", 2);
o([l({
  type: Boolean,
  reflect: !0
})], t.prototype, "dismissed", 2);
o([l({
  reflect: !0
})], t.prototype, "emphasis", 2);
o([l({
  type: String
})], t.prototype, "headerText", 2);
o([l({
  type: Boolean,
  reflect: !0
})], t.prototype, "notDismissible", 2);
o([l({
  reflect: !0
})], t.prototype, "status", 2);
o([l({
  reflect: !0
})], t.prototype, "variant", 2);
customElements.get("leaf-alert") === void 0 && customElements.define("leaf-alert", t);
export {
  t as LeafAlert,
  t as default
};
